// @flow

export { MealVoucherPage } from './meal-voucher-page';
